import { Navigate, Outlet } from 'react-router-dom';
import { getRole, isCsrPartner } from './role';

const CsrRoute = ({ support = false }) => {
  const allowed = support ? getRole() === 'SUPPORT' : isCsrPartner();
  return allowed ? <Outlet /> : <Navigate to="/" replace />;
};

export default CsrRoute;